export const selectors = {
  atcDrawer: '[js-atc-drawer]',
  dataScript: '[js-data-script]',
  atcDrawerContainer: '[js-atc-container]',
  atcDrawerClose: '[js-atc-drawer-close]',
  atcDrawerBack: '[js-atc-drawer-back]',
  atcDrawerService: '[js-drawer-service]',
  atcDrawerServiceOpen: '[js-drawer-service-open]',
  atcDrawerServiceClose: '[js-drawer-service-close]',
  atcDrawerServiceCheckbox: '[js-drawer-service-checkbox]',
  atcDrawerProductCard: '[js-product-card]',
  atcDrawerProductCardButton: '[js-product-cart-atc]',
  atcDrawerProductRecommendations: '[js-product-recommendations-cart]',
  atcDrawerProductRecommendationsSlider: '[js-cart-recommendations-slider]',
  atcProductButton: '[js-atc-product]',
  atcProductWithVariantsButton: '[js-atc-product-with-variants]',
  atcSelectorScripts: '[js-variant-selector-script]',
  atcDrawerQantityPlus: '[js-drawer-quantity-plus]',
  atcDrawerQantityMinus: '[js-drawer-quantity-minus]',
  atcDrawerQantityInput: '[js-drawer-quantity-input]',
  atcDrawerBuyButton: '[js-buy-button]',
}